<template>
  <div>
    <ul v-if="tempAttachments.length > 0" class="files">
      <li v-for="(tempAttachment, index) in tempAttachments" :key="tempAttachment._id">
        <div class="file-wrapper">
          <div class="file-thumb display-flex align-center">
            <img v-img src="" :src="tempAttachment.thumb" class="img-fluid" />
          </div>
          <div class="file-details">
            <div class="file-name display-flex align-center">
              <p class="" ref="attachmentTitle">{{ tempAttachment.title }}</p>
            </div>
            <div class="file-info">
              <span class="uploaded-date"> {{ tempAttachment.size }} bytes </span>
              <span v-if="checkProgress(tempAttachment)" class="upload-prgress">
                {{ `${tempAttachment.progress} %` }}
              </span>
            </div>
          </div>
          <a class="remove" @click="removeAttachment(index)"><i class="fa fa-ban" aria-hidden="true"></i></a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AttachmentList",
  methods: {
    checkProgress(attachment) {
      return attachment.progress === null ? false : true;
    },
    removeAttachment(index) {
      //console.log(this.tempAttachments);
      for(var i = 0; i < this.tempAttachments.length; i++) {
        //console.log(this.tempAttachments[i]._id);
        if(index == i) {
            this.tempAttachments.splice(i, 1);
            break;
        }
      }
    }
  },
  props: {
    tempAttachments: {
      type: Array
    },
    attachments: {
      type: Array
    }
  }
};
</script>

<style>
ul.files {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px;
  margin-top: 10px;
}
ul.files li {
  border: 1px solid #b2b2b2;
  margin-bottom: 8px;
  border-radius: 8px;
  margin-right: 8px;
  padding: 0;
  position: relative;
  max-width: 150px;
}
.file-details {
  padding: 5px;
}
.file-name {
  font-size: 12px;
  word-break: break-all;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 12px;
}
.remove {
  position: absolute;
  top: 2px;
  right: 7px;
  font-size: 12px;
  cursor: pointer;
  color: red !important;
}
</style>
